
export default [
  { title: "Bekaert Global", url: "https://www.bekaert.com/" },
  { title: "Bekaert Wire", url: "/spring-wire" },
  { title: "Bekaert Japan", url: "https://www.bekaert.com/ja" },
  {
    title: "Bekaert Costa Rica, Central America & Caribbean",
    url: "https://www.bekaert.com/en/product-catalog/content/related-sites/centro-america-y-caribe",
  },
  { title: "Bekaert Latin America", url: "https://www.bekaert.com/en/product-catalog/content/related-sites/bekaert-south-america" },
  { title: "Bekaert Fencing North America", url: "https://fencing.bekaert.com/en" },
  { title: "Bekaert Construction North America", url: "https://construction.bekaert.com" },
];
